import {
  CalculateInfo,
  CalculatedMplusInfo,
  GetMplusAvaliableParams,
  ICreditInfo,
  InitMInstalmentPayData,
  InitMplusPayData,
  MinstallmentResponse,
  MplusAvaliable,
  PurchaseResultMplus,
} from 'entities/mplus/module'

import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general.ts'

export const CreditInfo = {
  getCreditInfo() {
    return clientApi.get<Response<ICreditInfo>>(
      `payments/mplus/credit-line/info`,
    )
  },
  getCalculatedInfo(data: CalculateInfo) {
    return clientApi.post<Response<CalculatedMplusInfo>>(
      `payments/mplus/tranche/installment-info`,
      data,
    )
  },
  initPayMplus(data: InitMplusPayData) {
    return clientApi.post<Response<PurchaseResultMplus>>(
      `payments/mplus/tranche/init`,
      data,
    )
  },
  initPayMInstalment(data: InitMInstalmentPayData) {
    return clientApi.post<Response<MinstallmentResponse>>(
      `payments/minstallment/init`,
      data,
    )
  },
  getMplusAvaliable(data: GetMplusAvaliableParams) {
    return clientApi.get<Response<MplusAvaliable>>(
      `/flights/mplus_availability`,
      {
        params: {
          ...data,
        },
      },
    )
  },
}
